angular.module("SettingsApp").factory('DefaultSiteSubscriptionPackagesFactory', ['$resource', function ($resource) {
    return $resource('/api/v1.0/subscription-packages/default-subscription-packages/', {}, {});
}]);